import CustomLabel from "../../../../shapes/labels/CustomLabel";
import { MOVE_LABEL, NEW_CUSTOM_LABEL } from "../../../../tools/actions/ActionHelper";
import AbstractField from "../AbstractField";
import CustomLabelField from "./CustomLabelField";
import NewLabelButton from "./NewLabelButton";
import SpeciesLabelField from "./SpeciesLabelField";

export default class SpeciesLabelList extends AbstractField {
    rows = [];

    populate(element) {
        this._currentLabels = element.labels;
        this.rows.map(row => row.delete());
        this.sortable?.destroy();

        if (!this.touch) {
            this.newLabelButton?.delete();
            this.newLabelButton = new NewLabelButton(
                this.provider,
                this.newLabelContainer,
                element.labels,
                0,
                this.rowContainer
            );
        }

        this.rows = element.labels.labels.map(label => {
            if (label instanceof CustomLabel) {
                return new CustomLabelField(this.provider, label, this.rowContainer);
            } else {
                return new SpeciesLabelField(this.provider, label, this.rowContainer);
            }
        });
        let action = null;
        this.sortable = Sortable.create(this.rowContainer.elt, {
            handle: '.move-icon',
            delay: 100,
            delayOnTouchOnly: true,
            touchStartThreshold: 4,
            fallbackTolerance: 3,
            onChoose: (evt) => {
                this.rows.map(r => r.drag());
            },
            onUnchoose: (evt) => {
                this.rows.map(r => r.endDrag());
            },
            onStart: (evt) => {
                action = this.actions.new(MOVE_LABEL, element.labels, this.rows);
            },
            onEnd: (evt) => {
                action.finish(evt.oldIndex, evt.newIndex);
                action = null;
            },
        });
    }

    make() {
        this.field = this.p.createDiv().class('input-group');

        const headerRow = this.p.createDiv()
            .parent(this.field)
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('justify-content', 'space-between');
        this.label = this.p.createElement('h3', 'Species/Labels')
            .parent(headerRow)
            .class('input-label')
            .style('margin-top', '0px')
            .style('margin-bottom', '0px');
        // if (this.touch) {
            this.p.createButton('➕')
                .parent(headerRow)
                .style('background', 'none')
                .style('border', 'none')
                .style('cursor', 'pointer')
                .style('font-size', '16px')
                .style('padding', '0 4px')
                .attribute('data-tooltip', 'Add label')
                .mouseClicked(() => {
                    if (this._currentLabels) {
                        this.actions.new(NEW_CUSTOM_LABEL, this._currentLabels, this._currentLabels.length, this.rowContainer);
                    }
                });
        // }

        this.newLabelContainer = this.p.createDiv()
            .parent(this.field);
        this.rowContainer = this.p.createDiv()
            .parent(this.field)
            .id('species-list');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.initialized = true;
        return this;
    }

    reset() {
        this.rows.map(row => row.delete());
        this.rows = [];
    }

    add(field, index) {
        this.rows.splice(index, 0, field);
    }
}
